import { MultiSelect, MaterialSymbol, withStyles, MultiSelectProps, createSyntheticEvent } from 'vopay';
import styles from './MultiselectOutsideOptions.module.scss';

const classes = withStyles(styles);

type OptionType = { label?: string; value?: string; [key: string]: unknown };

export type MultiSelectOutsideOptionsProps<T extends OptionType = OptionType> = Omit<
  MultiSelectProps<T>,
  'value' | 'renderSelectedValue'
> & {
  value: string[];
};

export const MultiselectOutsideOptions = <T extends OptionType = OptionType>({
  options,
  value,
  onChange,
  disabled,
  name,
  ...rest
}: MultiSelectOutsideOptionsProps<T>) => {
  const valueArray: string[] = value.filter(Boolean) || [];

  const handleRemove = (optionValue: string) => {
    const filteredList = valueArray.filter((v) => v !== optionValue);
    const selectedOptions = options?.filter((opt) => filteredList.includes(opt.value || opt.label || '')) || [];
    const syntheticEvent = createSyntheticEvent<HTMLInputElement>(name, filteredList.join(','));
    onChange?.(syntheticEvent, { options: selectedOptions });
  };

  return (
    <>
      <MultiSelect<T>
        name={name}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...rest}
        renderSelectedValue={(_, { Placeholder }) => <Placeholder />}
      />
      {!!valueArray.length && (
        <div className={classes('multiselectOptionsContainer')}>
          {valueArray.map((v) => {
            const option = options?.find((opt) => opt.value === v || opt.label === v);
            const displayLabel = option?.label || v;

            return (
              <div key={v} className={classes('multiselectOption')}>
                <span>{displayLabel}</span>
                <div
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                  onClick={() => !disabled && handleRemove(v)}
                >
                  <MaterialSymbol icon="close" />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default MultiselectOutsideOptions;
